import { render, staticRenderFns } from "./CardListFavouriteItems.vue?vue&type=template&id=49228f9b"
import script from "./CardListFavouriteItems.vue?vue&type=script&lang=js"
export * from "./CardListFavouriteItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49228f9b')) {
      api.createRecord('49228f9b', component.options)
    } else {
      api.reload('49228f9b', component.options)
    }
    module.hot.accept("./CardListFavouriteItems.vue?vue&type=template&id=49228f9b", function () {
      api.rerender('49228f9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/CardListFavouriteItems.vue"
export default component.exports